"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable no-script-url */

var Overlay = function Overlay(props) {
  var title = props.title,
    backLink = props.backLink,
    _props$breadcrumbs = props.breadcrumbs,
    breadcrumbs = _props$breadcrumbs === void 0 ? [] : _props$breadcrumbs,
    children = props.children,
    inModal = props.inModal,
    className = props.className,
    TopBar = props.TopBar;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, inModal && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].modalBg
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " ").concat(inModal ? _style["default"].modal : ''),
    style: props.style,
    id: "cccisd-assignment-overlay"
  }, TopBar ? /*#__PURE__*/_react["default"].createElement(TopBar, null) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topBar
  }, /*#__PURE__*/_react["default"].createElement("h2", null, title), breadcrumbs.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].breadcrumbs
  }, breadcrumbs.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, item);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].backLink
  }, backLink || /*#__PURE__*/_react["default"].createElement("a", {
    href: "javascript:history.back()"
  }, "Go Back"))), children));
};
Overlay.propTypes = {
  backLink: _propTypes["default"].node,
  breadcrumbs: _propTypes["default"].array,
  className: _propTypes["default"].string,
  inModal: _propTypes["default"].bool,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
Overlay.defaultProps = {
  className: ''
};
var _default = exports["default"] = Overlay;